import React, { useState } from "react";

const GreenInitiativesSection = ({
                                     title = "Nachhaltigkeit bei uns",
                                     description = "Als Anbieter moderner Cloud-Lösungen legen wir großen Wert auf Effizienz und Umweltschutz. Unsere Services sind auf Nachhaltigkeit ausgelegt und unterstützen euch dabei, CO2-Emissionen zu reduzieren.",
                                     initiatives = [
                                         {
                                             icon: (
                                                 <svg
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     fill="none"
                                                     viewBox="0 0 24 24"
                                                     strokeWidth="1.5"
                                                     stroke="currentColor"
                                                     className="h-10 w-10 text-green-500"
                                                 >
                                                     <path
                                                         strokeLinecap="round"
                                                         strokeLinejoin="round"
                                                         d="m20.893 13.393-1.135-1.135a2.252 2.252 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.411-2.353a2.25 2.25 0 0 0 .286-.76m11.928 9.869A9 9 0 0 0 8.965 3.525m11.928 9.868A9 9 0 1 1 8.965 3.525"
                                                     />
                                                 </svg>
                                             ),
                                             title: "100% Ökostrom",
                                             info: "Unsere Cloud-Infrastruktur wird in Deutschland betrieben, das Rechenzentren mit 100% erneuerbaren Energien nutzt.",
                                             details: "Unser Hosting erfolgt CO2-neutral und trägt aktiv zur Reduzierung von Emissionen bei. Damit setzen wir auf einen nachhaltigen und umweltfreundlichen Betrieb."
                                         },
                                         {
                                             icon: (
                                                 <svg
                                                     xmlns="http://www.w3.org/2000/svg"
                                                     fill="none"
                                                     viewBox="0 0 24 24"
                                                     strokeWidth="1.5"
                                                     stroke="currentColor"
                                                     className="h-10 w-10 text-green-500"
                                                 >
                                                     <path
                                                         strokeLinecap="round"
                                                         strokeLinejoin="round"
                                                         d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                                                     />
                                                 </svg>
                                             ),
                                             title: "Serverless Lösungen",
                                             info: "Unsere Cloud-Services sind flexibel, effizient und reduzieren den Ressourcenverbrauch auf ein Minimum.",
                                             details:
                                                 "Serverless Technologien ermöglichen es uns, Leistung bereitzustellen, wenn sie gebraucht wird – und nur dann. Das spart Energie und Kosten.",
                                         },
                                     ],
                                     additionalClassName = "",
                                 }) => {
    const [selectedInitiative, setSelectedInitiative] = useState(null);

    const handleInitiativeClick = (initiative) => {
        setSelectedInitiative(initiative);
    };

    const closePopup = () => {
        setSelectedInitiative(null);
    };

    return (
        <section className={`py-12 md:py-24 lg:py-32 bg-black ${additionalClassName}`}>
            <div className="container mx-auto px-4 md:px-6">
                <div className="text-center max-w-3xl mx-auto">
                    <h2 className="text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl text-white">
                        {title}
                    </h2>
                    <p className="mt-4 text-zinc-300 md:text-lg">{description}</p>
                </div>
                <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-8">
                    {initiatives.map((initiative, index) => (
                        <div
                            key={index}
                            className="p-6 bg-zinc-900 rounded-lg shadow cursor-pointer hover:bg-zinc-800"
                            onClick={() => handleInitiativeClick(initiative)}
                        >
                            <div className="text-4xl mb-4">{initiative.icon}</div>
                            <h3 className="text-xl font-semibold text-white mb-2">
                                {initiative.title}
                            </h3>
                            <p className="text-zinc-400">{initiative.info}</p>
                        </div>
                    ))}
                </div>

                {selectedInitiative && (
                    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
                        <div className="bg-zinc-900 p-6 rounded-lg shadow-lg max-w-lg w-full relative">
                            <button
                                onClick={closePopup}
                                type="button"
                                className="absolute top-4 right-4"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    aria-hidden="true"
                                    className="text-zinc-500 h-6 hover:text-zinc-400"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M6 18 18 6M6 6l12 12"
                                    />
                                </svg>
                            </button>
                            <div className="text-4xl mb-4">{selectedInitiative.icon}</div>
                            <h3 className="text-2xl font-semibold text-white mb-4">
                                {selectedInitiative.title}
                            </h3>
                            <p className="text-zinc-400">{selectedInitiative.details}</p>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default GreenInitiativesSection;
